import mainImg from "../../assets/images/TopSection/top-section-main-img.png";
import React from "react";

export default function TopSection() {
  return (
    <section className="top-section-wrapper" id="главная">
      <img src={ mainImg } alt="society"/>
      <h1>пока мы делаем социальную<br/> сеть для общения,<br/>
      давайте<br/>
        <span className="top-section-marked">знакомиться</span></h1>
    </section>
  );
}
